export default function FileIcon() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2503 1H2.24996C2.05106 1 1.8603 1.07903 1.71965 1.21968C1.57901 1.36033 1.5 1.55109 1.5 1.75V18.25C1.5 18.4489 1.57901 18.6397 1.71965 18.7803C1.8603 18.921 2.05106 19 2.24996 19H15.75C15.9489 19 16.1397 18.921 16.2803 18.7803C16.421 18.6397 16.5 18.4489 16.5 18.25V6.25M11.2503 1L16.5 6.25M11.2503 1L11.25 6.25H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
